import store from "../app/store";
import {createAction} from "@reduxjs/toolkit";
import {ACTION_REPORTS_CHANGED} from "./ReportsPageReducer";
import {getSortAndFilterQueryString} from "../view/urlService";
import {securedFetch} from "../auth/authService";
import {REPORT_API, REPORT_SCHEDULE_API} from "../vars";
import {getAuthHeader} from "../auth/authService";

export function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${REPORT_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_REPORTS_CHANGED)({reports: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}

export function createReport(report) {
    return securedFetch(`${REPORT_API}/new`, withBrowserTimeZone(report), 'POST');
}

export function scheduleReport(reportSchedule) {
    return securedFetch(`${REPORT_SCHEDULE_API}`, withBrowserTimeZone(reportSchedule), 'POST');
}

export function getReportSchedules(userRole) {
    return securedFetch(`${REPORT_SCHEDULE_API}?userRole=${userRole}`).then(response => response.json());
}

export function changeReportScheduleActive(id, active) {
    return securedFetch(`${REPORT_SCHEDULE_API}/${id}?active=${active}`, null, 'POST');
}

export function deleteReportSchedule(id) {
    return securedFetch(`${REPORT_SCHEDULE_API}/${id}`, null, 'DELETE');
}

export async function deleteReports(idList) {
    for (const id of idList) {
        await securedFetch(`${REPORT_API}?id=${id}`, null, 'DELETE');
    }
}

export function downloadReport(report) {
    //const token = localStorage.getItem('access_token');
    const token = sessionStorage.getItem('access_token');

    fetch(`${REPORT_API}/download?id=${report.id}&_ticket=${token}`)
        .then(resp => resp.blob()).then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = report.name + '.pdf';
            a.click();
            // let url = window.URL.createObjectURL(blob);
            // const a = document.createElement('a');
            // a.href = url; //URL.createObjectURL(blob);
            // a.textContent = 'DOWNLOAD';
            // a.download = report.name + '.pdf'; //'dummy.pdf';
            // document.body.append(a);
            // a.click();

            // var textFileAsBlob = blob;//, {type: 'text/plain'});
            // var downloadLink = document.createElement("a");
            // downloadLink.download = report.name + '.pdf'; //fileName;
            // if (window.webkitURL != null) {
            //     downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob);
            // } else {
            // downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
            // //downloadLink.onclick = document.body.removeChild(event.target);
            // downloadLink.style.display = "none";
            // document.body.appendChild(downloadLink);
            // }
            // downloadLink.click();
              
        })
}

export function createInstantReport(report) {
    return securedFetch(`${REPORT_API}/new`, withBrowserTimeZone(report), 'POST');
        //.then(response => response); 
}
export function downloadInstantReport(filename) {
    const token = sessionStorage.getItem('access_token');

    fetch(`${REPORT_API}/downloadinstantstream?filename=${filename}&_ticket=${token}`)
        .then(resp => resp.blob()).then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename + '.pdf';
            a.click();              
        })
}
export async function deleteInstantReport(filename) {
    await securedFetch(`${REPORT_API}/deleteinstant?filename=${filename}`, null, 'DELETE');

}

export function uploadReportLogo(file) {
    const formData = new FormData();
    formData.append('image', file);
    //formData.append('filename', 'reportlogo');

    
    return fetch(`${REPORT_API}/uploadlogo`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        }).then(response => response);
        // .then(async response => {
        //     if (response.ok) {
        //         showSuccessToast(
        //             "Logo Uploaded",
        //             "Report Logo"
        //         );
        //     } else {
        //         response = await response.json()
        //         showDangerToast(response.message, "Error")
        //     }
        //     return !!response.ok
        // })
}

//view report logic
export function viewReport(report) {
    const token = sessionStorage.getItem('access_token');
    fetch(`${REPORT_API}/download?id=${report.id}&_ticket=${token}`)
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
}

function withBrowserTimeZone(payload) {
    return {
        ...payload,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
}
